/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Site_DescriptionInputs */

const en_site_description = /** @type {(inputs: Site_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Access ${i?.count} scraping and data APIs behind one key with automatic failover when a provider breaks. Pay per request from a prepaid USD wallet. No card to start.`)
};

const zh_hans1_site_description = /** @type {(inputs: Site_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`用 1 个密钥访问 ${i?.count} 个数据抓取和数据 API，服务商出故障时自动切换。从预付费美元钱包按请求付费，无需绑卡即可开始。`)
};

const pt_br2_site_description = /** @type {(inputs: Site_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Acesse ${i?.count} APIs de scraping e dados com uma única chave, com failover automático quando um provedor falha. Pague por requisição com uma carteira pré-paga em dólares. Comece sem cartão.`)
};

const es_site_description = /** @type {(inputs: Site_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Accede a ${i?.count} APIs de scraping y datos con una sola clave y respaldo automático cuando un proveedor falla. Paga por solicitud desde una billetera prepagada en dólares. Sin tarjeta para empezar.`)
};

const fr_site_description = /** @type {(inputs: Site_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Accédez à ${i?.count} API de scraping et de données avec une seule clé et un basculement automatique quand un fournisseur tombe. Payez par requête depuis un portefeuille prépayé en USD. Aucune carte pour commencer.`)
};

const de_site_description = /** @type {(inputs: Site_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Greife mit einem Schlüssel auf ${i?.count} Scraping- und Daten-APIs zu, mit automatischem Failover, wenn ein Anbieter ausfällt. Zahle pro Anfrage von einem Prepaid-Guthabenkonto in USD. Zum Start keine Karte nötig.`)
};

const ru_site_description = /** @type {(inputs: Site_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Доступ к ${i?.count} API для скрапинга и данных по одному ключу, с автоматическим переключением при сбое поставщика. Платите за запрос из предоплаченного кошелька в долларах США. Карта для старта не нужна.`)
};

const it_site_description = /** @type {(inputs: Site_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Accedi a ${i?.count} API di scraping e dati con una sola chiave, con failover automatico quando un provider si blocca. Paga a richiesta da un portafoglio prepagato in USD. Nessuna carta per iniziare.`)
};

/**
* | output |
* | --- |
* | "Access {count} scraping and data APIs behind one key with automatic failover when a provider breaks. Pay per request from a prepaid USD wallet. No card to st..." |
*
* @param {Site_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const site_description = /** @type {((inputs: Site_DescriptionInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_DescriptionInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_site_description(inputs)
	if (locale === "pt-BR") return pt_br2_site_description(inputs)
	if (locale === "es") return es_site_description(inputs)
	if (locale === "fr") return fr_site_description(inputs)
	if (locale === "de") return de_site_description(inputs)
	if (locale === "ru") return ru_site_description(inputs)
	if (locale === "it") return it_site_description(inputs)
	return en_site_description(inputs)
});